<template>
    <Modal :title="getTitle()" ref="modalRef">
        <template v-slot:body>
            <div class="margin-b-1">
                Group for the following {{ props.companies.length }} companies:
                <CompanyList :companies="props.companies" :allow-delete="true" ref="companyListRef"/>
            </div>
            <div class="margin-b-2">Parent company name:</div>
            <div class="margin-b-1">
                <input class="parent-name-text" type="text" v-model="name" />
            </div>
            <div class="margin-b-2">Parent company notes:</div>
            <textarea v-model="notes" class="parent-notes-text"></textarea>
        </template>
        <template v-slot:footer>
            <div class="edit-group-footer">
                <div>
                    <input type="button" value="Delete" class="button button-danger" @click="deleteGroup()" />
                </div>
                <div>
                    <input class="cancel-button button button-secondary" type="button" value="Cancel" @click="cancel()" />
                    <input type="button" value="Save" class="button" @click="save()" />
                </div>
            </div>
        </template>
    </Modal>
</template>

<script setup>
    import { ref, inject, defineProps, defineEmits } from 'vue';
    import { Modal as ModalLib, promptModal } from 'jenesius-vue-modal';
    import { useSettingsStore } from '@/stores/SettingsStore';
    import Modal from './Modal.vue';
    import Confirm from '@/components/Confirm.vue';
    import EditCompany from '@/components/EditCompany.vue';
    import CompanyList from '@/components/CompanyList.vue';
    import Error from '@/components/Error.vue';

    const props = defineProps({
        groupId: {
            type: Number,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        notes: {
            type: String,
            default: ''
        },

        companies: {
            type: Array,
            required: true
        }
    });

    const emit = defineEmits([ModalLib.EVENT_PROMPT]);
    const api = inject('api');

    const name = ref(props.name);
    const notes = ref(props.notes);
    const modalRef = ref();
    const settingsStore = useSettingsStore();
    const companyListRef = ref();

    function getTitle() {
        let title = 'Edit Parent Company';

        if (settingsStore.debugMode) {
            title += ` (${props.groupId})`;
        }

        return title;
    }
    async function save() {
        try {
            const removedCompanies = companyListRef.value.removedCompanies;

            if (removedCompanies.length > 0) {
                modalRef.value.showActivityIndicator = true;
                const remainingCompanies = props.companies
                    .filter(c => removedCompanies.indexOf(c.id) === -1)
                    .map(c => c.id);
                await api.editGroup(props.groupId, name.value, notes.value, remainingCompanies);
                modalRef.value.showActivityIndicator = false;
            }

            emit(ModalLib.EVENT_PROMPT, true);
        }
        catch (err) {
            promptModal(Error, { message: 'Error saving parent company', details: err.stack });
        }
    }

    function cancel() {
        emit(ModalLib.EVENT_PROMPT, false);
    }

    async function deleteGroup() {
        const data = {
            title: 'Delete Parent',
            text: 'Are you sure you want to delete this parent? This will not affect any companies or contacts in R2.',
            confirmBtnText: 'Delete',
            dangerous: true
        };

        const res = await promptModal(Confirm,  data);

        if (res) {
            try {
                await api.deleteGroup(props.groupId);
                emit(ModalLib.EVENT_PROMPT, true);
            }
            catch (err) {
                promptModal(Error, { message: 'Error deleting parent', details: err.stack });
            }
        }        
    }
</script>

<style scoped>
    .parent-name-text {
        width: 100%;
    }

    .parent-notes-text {
        width: 100%;
        height: 200px;
        resize: none;
    }

    .edit-group-footer {
        flex: 1;
        display: flex;
        justify-content: space-between;
    }

    .cancel-button {
        margin-right: 10px;
    }

    .del {
        /* color: #cc0000; */
    }

    .delete-spacer {
        margin-left: 10px;
    }

    .delete-cancel {
        color: #cc0000;
        cursor: pointer;
    }

    .company-name {
        margin-left: 10px;
    }
</style>
